import {
  Button,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { Autocomplete } from "@material-ui/lab";
import React, { useEffect, useState } from "react";
//import { CamposReporte } from "../../models/controlls.model";

interface AutoCompleteResponsiveProps {
  collection: any[];
  parentCampos: any;
  parentSetCampos: any;
  parentFilterSelected: any;
  parentSetFilterSelected: any;
  parentLimpiarFiltros: any;
  parentEliminaCampoImput: any;
  parentcurrentSize: number;
}

const AutoCompleteResponsive = (props: AutoCompleteResponsiveProps) => {
  const {
    collection,
    parentCampos,
    parentSetCampos,
    parentFilterSelected,
    parentSetFilterSelected,
    parentLimpiarFiltros,
    parentEliminaCampoImput,
    parentcurrentSize,
  } = props;

  const [options, setOptions] = useState<any[]>();
  const [value, setValue] = useState<any[]>(parentCampos);
  const [filterSelected, setFilterSelected] = useState("DatosEstadisticos");
  const [showMenu, setShowMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isAllSelect, setIsAllSelect] = useState<boolean>(false);
  let currentSize = parentcurrentSize;
  //const [camposReporte, setCamposReporte] = useState<Array<CamposReporte>>([]);

  const withUnderLine = {
    textDecorationLine: "underline",
    width: "100%",
    height: "100%",
  };
  const withOutUnderLine = {
    width: "100%",
    height: "100%",
  };

  useEffect(() => {
    currentSize = parentcurrentSize;
  }, [parentcurrentSize]);

  useEffect(() => {
    let opt: string[] = [];
    const mobile = window.screen.width < 1000;
    if (mobile) {
      parentSetFilterSelected(filterSelected);
    }
    collection
      ?.filter((e) => e.apartado === filterSelected)
      .forEach((x: any, i: number) => {
        if (filterSelected === "Sentencias" && i + 1 > 1) return;

        opt.push(`${x.alias}-2-${x.nombreColumna}-${x.apartado}`);
      });
    setOptions(opt);
  }, [collection, filterSelected]);

  useEffect(() => {
    if (parentCampos) setValue(parentCampos);
  }, [parentCampos]);

  useEffect(() => {
    isAllSelect
    ? handleSelectAll()
    : handleUnselectAll()
  }, [isAllSelect])

  const handleClose =
    (operador: string) => (event: React.MouseEvent<HTMLElement>) => {
      setShowMenu(false);
      setAnchorEl(null);
    };

  const handleClickIco = (event: React.MouseEvent<HTMLButtonElement>) => {
    let element = document.getElementById(
      event.currentTarget.id
    ) as HTMLElement;
    setAnchorEl(element);
    setShowMenu(true);
  };

  const handleFilterSelected = (event: React.MouseEvent<HTMLButtonElement>) => {
    let selected = event.currentTarget.id;
    setFilterSelected(selected);
    setShowMenu(false);
  };

  const handleExecSelection = (value: any[]) => {
    let datas = [...value];

    if (currentSize < datas.length) {
      let lastItem = datas[datas.length - 1];
      let key = lastItem.split("-")[0] + "-2";
      if (lastItem.split("-")[2] === "BuscarSentencias") {
        let keys: string[] = [
          key,
          "Sala-2",
          "Medio-2",
          "Consecutivo-2",
          "Año-2",
        ];
        parentSetCampos(keys);
        setValue(keys);
      } else {
        setValue([...value]);
        parentSetCampos([...value]);
      }
    } else {
      if (filterSelected === "Sentencias") {
        parentLimpiarFiltros();
      } else {
        setValue([...value]);
        parentSetCampos([...value]);
      }
    }

    currentSize = value.length;
    setIsAllSelect(currentSize > 0);
  };

  const handleDeleteChip = (idCampo: any) => {
    parentEliminaCampoImput(idCampo, false);
  };

  const handleSelectAll = () => {
    if (filterSelected === 'Sentencias') {
      let keys: string[] = [
        "Texto en sentencias-2",
        "Sala-2",
        "Medio-2",
        "Consecutivo-2",
        "Año-2",
      ];
      parentSetCampos(keys);
      setValue(keys);
      return;
    }

    if (value.length > 0) return;

    let newOptions = options?.filter(i => i !== "Año del proceso electoral-2-AnioProcesoElectoral-DatosEstadisticos");

    parentSetCampos([...newOptions ?? []]);
    setValue([...newOptions ?? []]);
  }

  const handleUnselectAll = () => {
    parentSetCampos([]);
    setValue(parentCampos);
  }

  // onChange={(_, value: any[]) => {
  // parentFilterSelected(value[0].split('-')[3])
  // let key = value[0].split('-')[0] + "-2";
  // if (value[0].split('-')[2] === "BuscarSentencias") {
  //   let keys: string[] = [key, "Sala-2", "Medio-2", "Consecutivo-2", "Año-2"];
  //   parentSetCampos(keys);
  //   setValue([...value]);
  //   return;
  // }

  // parentSetCampos([...value]);
  // setValue([...value]);
  // options?.forEach((v: any) => {
  //   if (v.split("-")[0] !== "Buscar en sentencias") {
  //     let d = document.getElementById(
  //       `${v.split("-")[0]}`
  //     ) as HTMLElement;

  //     if (d) d.style.display = value.indexOf(v) !== -1 ? "none" : "block";
  //   }
  // });
  // }}

  return (
    <Autocomplete
      freeSolo
      style={{ margin: "0 1%", width: "97%" }}
      multiple={true}
      id={`acl-Campos`}
      options={options ?? []}
      defaultValue={parentCampos ?? []}
      getOptionLabel={(option) => `${option.split("-")[0]}`}
      onChange={(event: any, value: any[]) => handleExecSelection(value)}
      renderOption={(option) => (
        <Typography style={{ fontSize: "13px" }}>{`${
          option.split("-")[0]
        }`}</Typography>
      )}
      value={value}
      renderTags={(value: string[], getTagProps) =>
        value.map((option: string, index: number) => (
          <Chip
            key={`chip-${option}-${index}`}
            variant="outlined"
            label={`${option.split("-")[0]}`}
            {...getTagProps({ index })}
            onDelete={() => handleDeleteChip(option)}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Campos seleccionados"
          variant="standard"
          style={{ fontSize: "13px" }}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                <>
                  <Tooltip title="Tipo de búsqueda">
                    <IconButton
                      id={`ico-responsive`}
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleClickIco}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Tooltip>
                  <Menu
                    id={`menu-responsive`}
                    keepMounted
                    open={showMenu}
                    anchorEl={anchorEl}
                    onClose={handleClose("")}
                  >
                    <MenuItem id={`subM1-responsive`}>
                      <span
                        id="DatosEstadisticos"
                        onClick={handleFilterSelected}
                        style={
                          filterSelected === "DatosEstadisticos"
                            ? withUnderLine
                            : withOutUnderLine
                        }
                      >
                        Datos estadísticos
                      </span>
                    </MenuItem>
                    <MenuItem id={`subM2-responsive`}>
                      <span
                        id="Sentencias"
                        onClick={handleFilterSelected}
                        style={
                          filterSelected === "Sentencias"
                            ? withUnderLine
                            : withOutUnderLine
                        }
                      >
                        Sentencias
                      </span>
                    </MenuItem>
                  </Menu>
                  {
                    !isAllSelect
                    ? (
                      <Tooltip title="Seleccionar todo">
                        <IconButton
                          id={`ico-responsive`}
                          aria-label="more"
                          aria-controls="long-menu"
                          aria-haspopup="true"
                          onClick={() => setIsAllSelect(true)}
                        >
                          <AddIcon />
                        </IconButton>
                      </Tooltip>
                    )
                    : (
                      <Tooltip title="Eliminar todo">
                        <IconButton
                          id={`ico-responsive`}
                          aria-label="more"
                          aria-controls="long-menu"
                          aria-haspopup="true"
                          onClick={() => setIsAllSelect(false)}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    )
                  }
                </>
              </React.Fragment>
            ),
          }}
          InputLabelProps={{
            ...params.InputLabelProps,
          }}
        />
      )}
    />
  );
};

export default AutoCompleteResponsive;
